// extracted by mini-css-extract-plugin
export default {"bottomButtons":"bottomButtons"};